var _defs, _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconUsername = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .username-class-a {\n                fill: #f5f8fa;\n                fill-rule: evenodd;\n            }\n\n            .username-class-b {\n                fill: none !important;\n            }\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "username-class-a",
    d: "M5809.246-3441.454a6.283,6.283,0,0,1,6.282,6.282,6.283,6.283,0,0,1-6.282,6.282,6.281,6.281,0,0,1-6.282-6.282A6.281,6.281,0,0,1,5809.246-3441.454Zm0,2.094a4.189,4.189,0,0,0-4.19,4.188,4.189,4.189,0,0,0,4.19,4.188,4.188,4.188,0,0,0,4.187-4.188A4.188,4.188,0,0,0,5809.246-3439.36Zm0,12.564a8.376,8.376,0,0,1,8.374,8.375v2.094h-16.751v-2.094A8.376,8.376,0,0,1,5809.246-3426.8Zm0,2.094a6.281,6.281,0,0,0-6.279,6.046l0,.235h12.563a6.284,6.284,0,0,0-6.046-6.278Z",
    transform: "translate(-5793.118 3444.95)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "username-class-b",
    width: 32,
    height: 32
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconUsername);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_username.6e75f0a5df339783ff7bc3161af60cfd.svg";